<template>
  <div class="user-container">
    <nav class="add-navigation">
      <div class="right-wrapprr unset_flex flex-wrap flex">
        <search-input
          class="search-input  sm-w-100"
          type="text"
          v-model="SearchUser"
          placeholder="Search for user"
        />
        <div class="reset-button margin_button ">
          <primary-button
            @click.native="reasetFilters"
            class="button_margin reset-margin-size"
            style="width: 90%; margin-left: 20px"
            >Reset</primary-button
          >
        </div>
        <div class="show-active-items sm-mt-2 active-only-margin-size">
          <input
            type="checkbox"
            id="show-active"
            class="active-checkbox "
            v-model="isActive"
          />
          <label for="show-active">Active Only</label>
        </div>
      </div>
      <!-- <div class="buttons-wrapper">
        <div class="primary-button">
          <primary-button
            @click.native="$router.push({ name: 'system-admin-add-user' })"
            >Create</primary-button
          >
        </div>
      </div> -->
    </nav>

    <loader :loading="loading" v-if="loading" />
    <template v-else>
      <not-found v-if="isFound" />
      <div
        v-else
        class="table_div"
        style="width: 100%; overflow-x: auto; overflow-y: hidden"
      >
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th style="min-width: 270px">
                Name
                <span v-on:click="sorting('up', 'full_name')" class="sorting"
                  >&#8593;</span
                >
                <span v-on:click="sorting('down', 'full_name')" class="sorting"
                  >&#8595;</span
                >
              </th>
              <th>
                Created by
                <span v-on:click="sorting('up', 'created_by')" class="sorting"
                  >&#8593;</span
                >
                <span v-on:click="sorting('down', 'created_by')" class="sorting"
                  >&#8595;</span
                >
              </th>
              <th>
                User Name
                <span v-on:click="sorting('up', 'user_name')" class="sorting"
                  >&#8593;</span
                >
                <span v-on:click="sorting('down', 'user_name')" class="sorting"
                  >&#8595;</span
                >
              </th>
              <th>
                Company Name
                <span v-on:click="sorting('up', 'company_name')" class="sorting"
                  >&#8593;</span
                >
                <span
                  v-on:click="sorting('down', 'company_name')"
                  class="sorting"
                  >&#8595;</span
                >
              </th>
              <th>
                Role
                <!-- <span v-on:click="sorting('up','company_name')" class="sorting">&#8593;</span>
                <span v-on:click="sorting('down','company_name')" class="sorting">&#8595;</span>-->
              </th>
              <th>
                Start From
                <span v-on:click="sorting('up', 'created_on')" class="sorting"
                  >&#8593;</span
                >
                <span v-on:click="sorting('down', 'created_on')" class="sorting"
                  >&#8595;</span
                >
              </th>
              <th style="width: 70px">Action</th>
            </tr>
          </thead>
          <tbody v-if="users.length > 0">
            <tr
              class="line"
              v-for="(user, k) in users"
              :key="k"
              :class="{
                active: user.status === 'active',
                inactive: user.status === 'inactive',
              }"
            >
              <th style="min-width: 260px">
                <div @click="changeStatus(user)" class="status"></div>

                <span>{{ user.fullName }}</span>
              </th>
              <th>{{ user.created_by }}</th>
              <th>{{ user.userName }}</th>
              <th>{{ !user.isAdmin ? user.companyName : "" }}</th>
              <th>{{ user.isAdmin ? "Admin" : "User" }}</th>
              <th>{{ user.createdOn }}</th>
              <th class="icon icon-right">
                <span title="Edit">
                  <svg
                          @click="
                    $router.push({
                      name: 'system-admin-edit-user',
                      params: { id: user.userId },
                    })
                  "
                          class="svg-grey"
                          width="30px"
                          height="30px"
                          viewBox="0 0 30 30"
                          version="1.1"
                  >
                  <path
                          d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                          id="path-1"
                  />
                </svg>
                </span>
                <span title="Delete">
                  <svg
                          @click="deleteUser(user.userId)"
                          class="svg-grey delete"
                          width="30px"
                          height="30px"
                          viewBox="0 0 30 30"
                          version="1.1"
                  >
                  <path
                          d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                          id="path-1"
                  />
                </svg>
                </span>

              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="justify-content-between mb-4" :style="{ display: paginationCondition ? 'flex' : 'block' }">
        <div class="show_perdiv">
          <span class="filter_by custom-row">Show Per Page:</span>
          <div class="primary-input-container choose-type perPage">
            <primary-select
              type="text"
              @input="changePerPage"
              v-model="per_page" :is-cross="false"
              class="choose-type perPage"
              placeholder="Select"
            >
              <option :value="item" v-for="(item, key) in pages" :key="key">
                {{ item }}
              </option>
            </primary-select>
          </div>
        </div>
        <div
          v-if="!isFound"
          class="buttons-wrapper"
          :class="{ pagination: paginationCondition }"
        >
          <pagination-component
            @change-page="changePage($event)"
            :page="Page"
            :total="TotalPages"
            :perPage="per_page"
            :qnt="users.length"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
  },
  data: () => ({
    showDropDown: false,
    users: [],
    SearchUser: "",
    TotalPages: null,
    Page: 0,
    // filter: "all",
    company: "",
    companies: [],
    pages: [10, 50, 100],
    per_page: 10,
    loading: true,
    filterBy: { active: "Active Only", inactive: "Inactive Only" },
    order_dir: "desc",
    order_by: "created_on",
    isFound: false,
    isActive: false,
  }),
  computed: {
    paginationCondition() {
      return this.users.length < this.per_page && this.Page === 0;
    },
  },
  watch: {
    SearchUser: function () {
      this.Page = 0;
      this.getUsersList(this.per_page, this.order_dir, this.order_by);
    },
    company: function () {
      this.Page = 0;
      this.getUsersList(this.per_page, this.order_dir, this.order_by);
    },
    isActive() {
      this.Page = 0;
      this.getUsersList();
    },
  },
  created() {
    this.getUsersList();
  },
  methods: {
    sorting(type, sortBy) {
      let order_dir = "";
      if (type === "up") {
        order_dir = "desc";
      } else {
        order_dir = "asc";
      }

      this.order_dir = order_dir;
      this.order_by = sortBy;

      this.getUsersList(this.per_page, order_dir, sortBy);
    },
    changeStatus(user) {
      if (user.status === "active") {
        user.status = "inactive";
        user.is_active = false;
      } else if (user.status === "inactive") {
        user.status = "active";
        user.is_active = true;
      }
      this.$store
        .dispatch("ChangeUserStatusListing", {
          // user: user,
          user_id: user.userId,
          is_active: user.is_active,
        })
        .then((res) => {
          this.$snotify.success("User status was changed.", {
            timeout: 6000,
          });
          this.getUsersList(this.per_page, this.order_dir, this.order_by);
        });
    },
    changePerPage(e) {
      this.Page = 0;
      this.getUsersList(
        this.per_page,
        this.order_dir,
        this.order_by
        // this.filter
      );
    },
    getCompanyList() {
      this.$store
        .dispatch("GetCompanyList", {
          perPage: 1000,
        })
        .then((res) => {
          this.companies = res.items;
        });
    },
    changePage(page) {
      this.Page = page;
      this.getUsersList(
        this.per_page,
        this.order_dir,
        this.order_by
        // this.filter
      );
    },
    getUsersList(
      total,
      order_dir = "desc",
      order_by = "created_on",
      filter = "all"
    ) {
      this.loading = true;
      this.isFound = false;
      this.$store
        .dispatch("GetUsers", {
          page: this.Page,
          user_name: this.SearchUser,
          company: this.company,
          // per_page: total ? parseInt(total) : 10,
          per_page: this.per_page,
          order_by: order_by,
          order_dir: order_dir,
          filter: filter,
          is_active: this.isActive,
          is_admin: "user",
        })
        .then((res) => {
          this.loading = false;
          if (!res.items.length) {
            this.isFound = true;
            return;
          }
          this.TotalPages = res.total / res.per_page;
          this.users = res.items.map(this.transformUsers);
        });
    },
    transformUsers(i, k) {
      return {
        fullName: i.full_name,
        companyName: i.company_name,
        createdOn: format(i.created_on, "YYYY:MM:DD HH:mm:ss"),
        role: i.rank, //i.role_name == 'user' ? 'Default' : 'Premium',
        userId: i.user_id,
        userName: i.user_name,
        path: i.logo_file_uuid,
        status: i.status,
        created_by: i.created_by,
        isAdmin: i.is_admin,
      };
    },
    reasetFilters() {
      this.SearchUser = "";
      // this.filter = "";
      this.company = "";
      this.getUsersList();
    },
    deleteUser(userId) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this user!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("DeleteUser", userId)
            .then((res) => {
              console.log("res--->", res);
              this.getUsersList();
              this.$swal({
                title: "Deleted!",
                text: "The User has been deleted.",
                type: "success",
              });
            })
            .catch((err) => {
              this.$snotify.error(err.response.statusText);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sorting {
  font-size: 18px;
  cursor: pointer;
}
.user-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;

  .show-active-items {
    display: flex;
    align-items: center;
    margin-left: 30px;
    // padding: 15px 0;

    .active-checkbox {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    label {
      width: 90px;
      margin-bottom: 0;
    }
  }
  .primary-input-container.perPage {
    width: 120px;
  }
  th.icon .radio-button.active {
    padding: 2px 3px 3px 23px;
    background-color: #24e2b8;
    border: 0;
  }
  th.icon .radio-button {
    height: 30px;
    width: 50px;
    border-radius: 15px;
    background-color: #ffffff;
    border: 1px solid #a6b6be;
    margin-left: 10px;
    padding: 1px 23px 3px 3px;
    cursor: pointer;
  }
  th.icon .radio-button svg {
    height: 24px;
    width: 24px;
  }
  .custom-row {
    margin-right: 7px;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .right-wrapprr {
      align-items: center;
      width: fit-content;
      .search-input {
        height: 40px;
        min-width: 220px;
        width: 40%;
        background-color: #ffffff;
        margin-bottom: 0;
      }
      .reset-button {
        height: 40px;
        width: 100px;
      }
      .selects-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
        .filter_by {
          height: 40px;
          width: 90px;
          color: #55616e;
          font-weight: normal;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
          padding: 10px 0 10px 30px;
          //margin-bottom: 10px;
        }
        .company {
          height: 40px;
          width: 150px;
          padding: 0 0 0 10px;
          color: #55616e;
          font-weight: normal;
        }
        .choose-company {
          height: 40px;
          width: 180px;
          padding: 0 10px 0 10px;
          color: #55616e;
          font-weight: normal;
        }
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      // width: fit-content;
      width: 100%;

      &.pagination {
        width: fit-content;
        flex-grow: 1;
      }
      .primary-button {
        height: 40px;
        width: 110px;
      }
    }
  }
}
.gap {
  width: 339px;
}
table.Invoice_table {
  width: 100%;

  th {
    text-align: center;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}
table thead th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
}
table,
tr {
  width: 100%;
  height: 40px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  float: right;
  width: 75px;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  padding: 10px 15px 10px 0;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 12px 20px;
  text-align: left;
}
tbody th.icon-right {
  display: flex;
  padding: 7px 0 7px 0;
  height: 40px;
  color: #55616e;
  float: right;
  min-width: 72px;
  .svg-grey {
    fill: #55616e;
    height: 30px;
    width: 30px;
    margin-right: 5px;
  }
}
table th:first-child {
  padding-left: 20px;
}
tbody th:first-child {
  padding: 0;
  span {
    padding: 12px 0;
  }
}
tbody th .did {
  font-size: 12px;
  width: 86px;
  height: 24px;
  padding-top: 0px;
  float: right;
}
tbody th.method {
  width: 110px;
  color: #55616e;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 25px;
}
.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 13px 0 12px 0;
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  vertical-align: middle;
  margin: 7px 8px 7px 0;
}
.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  // display: inline-grid;
  margin: 5px 10px 0 12px;
  float: left;
}
.active {
  th .status {
    background-color: #24e2b8;
  }
}
.inactive {
  th .status {
    background-color: #d2305b;
  }
  th.user_active:after {
    content: "";
    height: 10px;
    width: 10px;
    background-color: #24e2b8;
    position: absolute;
    border-radius: 50%;
    left: 12px;
    top: 17px;
    // margin: 17px 0 37px 12px;
  }

  th.user_active {
    text-align: left;
    position: relative;
    padding: 7px 0 7px 0;
  }
  th.smsText {
    color: #55616e;
    font-family: "Helvetica Neue";
    font-size: 14px;
    font-weight: normal;
    line-height: 25px;
    padding: 10px 0 10px 0;
  }
  th.status {
    padding: 10px 18px 10px 0;
    .approved {
      box-sizing: border-box;
      height: 24px;
      width: 80px;
      border: 2px solid #ffffff;
      border-radius: 100px;
      background-color: #24e2b8;
      color: #ffffff;
      font-family: "Helvetica Neue";
      font-size: 13px;
      font-weight: normal;
      line-height: 16px;
      padding: 4px 10px;
    }
    .rejected {
      box-sizing: border-box;
      height: 24px;
      width: 74px;
      border: 2px solid #ffffff;
      border-radius: 100px;
      background-color: #d2305b;
      color: #ffffff;
      font-family: "Helvetica Neue";
      font-size: 13px;
      font-weight: normal;
      line-height: 16px;
      padding: 4px 10px;
    }
  }

  th.icon {
    height: fit-content;
    display: flex;
    .primary {
      // padding-top: 11px;
      width: 90px;
      height: 30px;
      font-size: 12px;
      line-height: 20px;
      border-radius: 100px;
      margin-right: 10px;
    }
    .primary.active {
      border: 2px solid #ffffff;
      border-radius: 100px;
      background-color: #24e2b8;
      color: #ffffff;
      // opacity: 0.68;
    }
    .svg-grey {
      fill: #55616e;
    }
    .message {
      margin-right: 10px;
    }
    .edit {
      margin-left: 10px;
    }
    .delete {
      margin-right: 0px;
    }
    .radio-button {
      height: 30px;
      width: 50px;
      border-radius: 15px;
      background-color: #ffffff;
      border: 1px solid #a6b6be;
      margin-left: 10px;
      padding: 1px 23px 3px 3px;
      cursor: pointer;
      svg {
        height: 24px;
        width: 24px;
        // box-shadow: 2px 2px 7px 0 rgba(77,84,94,0.24);
      }
    }
    .radio-button.active {
      padding: 2px 3px 3px 23px;
      background-color: #24e2b8;
      border: 0;
    }
  }
  th.reseller {
    line-height: 25px;
    font-family: "Helvetica Neue";
    color: #000000;
  }
  .Invoice_table_sub_header th {
    height: 30px;
    color: #bdbfd8;
    font-family: "Helvetica Neue";
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 30px;
    padding: 5px 0 5px 15px;
  }
  th.allcompanies {
    padding-top: 20px;
  }

  .active {
    th .status {
      background-color: #24e2b8;
    }
  }
  .inactive {
    background-color: #f0f1fa;

    th .status {
      background-color: #d2305b;
    }
  }
}
.show_perdiv {
  display: flex;
  align-items: center;
  margin-top: 10px;
  span {
    color: #55616e;
    font-weight: normal;
    font-family: "Helvetica Neue";
  }
}
@media (max-width: 1680px) {
  table.Invoice_table {
    width: 1540px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
@media (min-width: 394px) {
  .unset_flex{
    display: flex;
  }

}
@media (max-width: 545px) {
  .margin_button{
       margin-top: 5px;
  }
}
@media (max-width: 394px) {
  .button_margin{
    margin-left: 30px !important;
  }
}
@media (max-width: 419px) {
  .reset-margin-size{
    margin-top: 12px;
  }
}
@media (max-width: 569px) {
  .active-only-margin-size{
    margin-top: 30px;
  }
}
</style>

